<template>
  <div v-if="visible"
    ref="widget"
    class="fixed bg-gray-800 text-white p-3 rounded-lg shadow-lg cursor-move"
    :style="{ top: position.y + 'px', left: position.x + 'px' }" style="width: 50px; height: 50px;"
    @mousedown="startDrag"
  >
    <!--<p class="text-sm font-semibold">📊 </p>-->
    <p>👤 {{ usersOnline }}</p>
    <p>🚶 {{ guestsOnline }}</p>
	<button @click.stop="closeWidget" class="text-red-400 ml-2" style="position: absolute;top: -21px;right: 0px;font-size: 10px;">❌</button>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      usersOnline: 0,
      guestsOnline: 0,
      position: { x: 160, y: window.innerHeight - 150 }, // Mặc định ở giữa bên phải
      dragging: false,
      offset: { x: 0, y: 0 },
	  visible: true,
	  intervalId: null
    };
  },
  computed: {
    ...mapState("user", ["isAuthenticated", "user"]),
  },
  methods: {
	closeWidget() {
      this.visible = false;
      clearInterval(this.intervalId); // Xóa interval
      this.intervalId = null;
    },
    fetchStatistics() {
      axios
        .post("/api/getOnlineUsers")
        .then((response) => {
          this.usersOnline = response.data.users_online;
          this.guestsOnline = response.data.guests_online;
        })
        .catch((error) => {
          console.error("Error fetching statistics", error);
        });
    },
    startDrag(event) {
      this.dragging = true;
      this.offset = {
        x: event.clientX - this.position.x,
        y: event.clientY - this.position.y,
      };
      window.addEventListener("mousemove", this.dragMove);
      window.addEventListener("mouseup", this.stopDrag);
    },
    dragMove(event) {
      if (!this.dragging) return;
      this.position = {
        x: event.clientX - this.offset.x,
        y: event.clientY - this.offset.y,
      };
    },
    stopDrag() {
      this.dragging = false;
      window.removeEventListener("mousemove", this.dragMove);
      window.removeEventListener("mouseup", this.stopDrag);
    },
  },
  mounted() {
    this.fetchStatistics();
    this.intervalId = setInterval(this.fetchStatistics, 5000); // Cập nhật mỗi 5 giây
  },
   beforeUnmount() {
    clearInterval(this.intervalId); // Xóa interval khi component bị huỷ
  },
};
</script>

<style scoped>
p {
  margin: 4px 0;
}
</style>
